import { gameByKey } from './gameMeta'
import { TitleCard } from '../TitleCard'

// ── GameOpen — the title card every daily opens on ───────────────────────────
// Now a thin wrapper over the app-wide TitleCard (17.145): the games were the first
// surface to get this card, and every route and page-level wait uses the same one.
// Pages keep their own 1.1s floor so this reads as a beat, not a flicker.
export function GameOpen({ game, day, caption }) {
  const g = gameByKey(game)
  const Icon = g.Icon
  return <TitleCard tone={g.tone} glyph={<Icon size={34} strokeWidth={2.2} />} eyebrow={`${g.eyebrow}${day != null ? ` · No. ${day}` : ''}`} title={g.label} line={g.promise} caption={caption || g.loading} />
}
